export const callPagApi = async (
  token: string = '',
  getToken: any,
  api: any,
  variables: any = null,
  signal: any
) => {
  try {
    if (!token) token = await getToken()

    const params: any = {
      context: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        fetchOptions: {
          signal,
        },
      },
    }

    if (variables) {
      params['variables'] = variables
    }

    api(params)

    return token
  } catch (error) {
    console.error(error)
  }
}

/** Authenticated GraphQL query that returns `data` (for callers that need the response body). */
export const fetchPagQuery = async (
  getToken: () => Promise<string>,
  apolloClient: { query: (options: any) => Promise<{ data?: any; errors?: any[] }> },
  query: any,
  variables: Record<string, unknown> | null = null
) => {
  const token = await getToken()
  const result = await apolloClient.query({
    query,
    variables,
    fetchPolicy: 'network-only',
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  })

  if (result.errors?.length) {
    throw new Error(result.errors.map((e: any) => e.message).join('; '))
  }

  return result.data
}
